/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UploadLimits } from '../models/UploadLimits';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StatusService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Ping
     * @returns string Successful Response
     * @throws ApiError
     */
    public pingApiV1StatusPingGet(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/status/ping',
        });
    }
    /**
     * Sample Error
     * @returns any Successful Response
     * @throws ApiError
     */
    public sampleErrorApiV1StatusSampleErrorGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/status/sample-error',
        });
    }
    /**
     * Get Limits
     * @returns UploadLimits Successful Response
     * @throws ApiError
     */
    public getLimitsApiV1StatusLimitsGet(): CancelablePromise<UploadLimits> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/status/limits',
        });
    }
}
